import React from "react";

import "./styles.css";
import styled from "styled-components";

export const STEPS = [
  "Pendente",
  "Criado",
  "Faturado",
  "Em separação",
  "Separado",
  "Enviado",
  "Entregue",
];

function Stepper({ step = "Pendente", size=10 }) {
  return (
    <BreadCrumb className="breadcrumb" size={size}>
      {STEPS.map((item, index) => {
        // should activate all previous steps and current step.... case insensitive
        const currentStepIndex = STEPS.findIndex(
          (s) => s.toLowerCase() === step.toLowerCase()
        );
        const isActive = index >= currentStepIndex;
        const isCurrent = index === currentStepIndex;
        return (
          <li
            key={index}
            className={isCurrent ? "current" : !isActive ? "inactive" : ""}
          >
            {item}
          </li>
        );
      })}
    </BreadCrumb>
  );
}
const BreadCrumb = styled.ul`
  font-size: ${props=>props.size}px !important;
  line-height: 1;
  list-style: none;
  padding: 0;
  margin: 0;
  border-radius: 0.5em;
  overflow: hidden;
`

export default Stepper;
